export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MainView.vue?vue&type=template&id=0e1608ff&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/userVideo/MainView.vue?vue&type=template&id=0e1608ff&
// module id = null
// module chunks = 